module.exports = {"Operate7":{"daobanList":[{"title":"1:是否需要办理娱乐场所的《娱乐经营许可证》？","values":[{"name":"是","xuanzhong":1,"cailiaoList":[{"name":"1、歌舞娱乐场所申请登记表","state":"必要"},{"name":"2、投资人、法定代表人和主要负责人的身份证明复印件","state":"必要"},{"name":"3、游艺娱乐场所申请登记表","state":"必要"},{"name":"4、场所产权证明","state":"必要"},{"name":"5、营业场所地理位置图","state":"必要"},{"name":"6、场所内部结构平面图","state":"必要"},{"name":"7、工商营业执照","state":"必要"},{"name":"8、游戏游艺设备登记表","state":"必要"},{"name":"9、歌舞娱乐场所关于歌曲点播系统合法性的说明材料，游艺娱乐场所关于游艺设备的型号清单","state":"必要"},{"name":"10、投资人、法定代表人和主要负责人的无犯罪记录的书面声明","state":"必要"}]},{"name":"否","xuanzhong":0,"cailiaoList":[{}]}]}]}}


//////////////////
// WEBPACK FOOTER
// ./static/js/situation/sdo-7.json
// module id = 1287
// module chunks = 0